/* eslint-disable camelcase */
import { put, select, delay } from 'redux-saga/effects';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    VALIDATE_PRODUCTS_SUCCESS,
    VALIDATE_PRODUCTS_FAILURE,
} from 'src/pages/more/pages/productGuide/redux/action/actionTypes';
import { convertObjectToQueryParams, generate_UUID } from 'src/utils/util';
import { setCartData } from 'src/pages/more/pages/productGuide/redux/action';
import { TISSUE_AND_NON_TISSUE_SALES_ORG } from 'src/constants/productConstants';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { filterProductsWithQuantityGreaterThanZero } from 'src/utils/util';
import { 
    getEquityValidateProductsDataServices,
    getValidatedProductsEndpoint 
} from 'src/pages/more/pages/productGuide/redux/services';

// var productsPrice = [];

const validateTissueAndNonTissueSalesOrgs = (
    { products, orderType },
    soldToAccount
) => {
    /*const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/validateproduct?`;*/

    const tissueSalesOrg = [];
    const nonTissueSalesOrg = [];
    const promiseArray = [];
    // const productsPrice = [];
    products.forEach((product) => {
        if (product.salesOrg === TISSUE_AND_NON_TISSUE_SALES_ORG.tissue)
            tissueSalesOrg.push(product.cfn);
        else nonTissueSalesOrg.push(product.cfn);
    });

    /*if (tissueSalesOrg.length > 0) {
        const tissueUrl = `${url}${convertObjectToQueryParams({
            productCFN: tissueSalesOrg.join(),
            salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.tissue,
            soldToAccount,
            orderType,
        })}`;*/

    /*  const tissuePromise = axios
            .get(tissueUrl)
            .then((response) => response.data);
        promiseArray.push(tissuePromise);*/

    if (tissueSalesOrg.length > 0) {
        const tissuePromise = getEquityValidateProductsDataServices(
            convertObjectToQueryParams({
                productCFN: tissueSalesOrg.join(),
                salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.tissue,
                soldToAccount,
                orderType,
            })
        );

        promiseArray.push(tissuePromise);
    }

    /*if (nonTissueSalesOrg.length > 0) {
        const nonTissueUrl = `${url}${convertObjectToQueryParams({
            productCFN: nonTissueSalesOrg.join(),
            salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
            soldToAccount,
            orderType,
        })}`;*/

    /*const nonTissuePromise = axios
            .get(nonTissueUrl)
            .then((response) => response.data);
        promiseArray.push(nonTissuePromise);*/

    if (nonTissueSalesOrg.length > 0) {
        const nonTissuePromise = getEquityValidateProductsDataServices(
            convertObjectToQueryParams({
                productCFN: nonTissueSalesOrg.join(),
                salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
                soldToAccount,
                orderType,
            })
        );
        promiseArray.push(nonTissuePromise);
    }
    // const getProductsPrice = getPricesForItemsDataService(
    //     convertObjectToQueryParams({
    //         productCFN: nonTissueSalesOrg.join(),
    //         sapPartnerId: soldToAccount,
    //         orderType,
    //     })
    // );
    // productsPrice.push(getProductsPrice);
    // const allPromise = Promise.all([promiseArray, productsPrice]);
    // return allPromise;
    return Promise.all(promiseArray);
};

export default function* validateProducts(action) {
    const { soldToAccount, inventoryShipping } = yield select((state) => ({
        soldToAccount: state.equityReducer.surgeryDetails?.accountId?.accountId,
        inventoryShipping: state.equityReducer.surgeryDetails.inventoryShipping,
    }));
    const { searchType, products, orderType } = action?.payload || {};
    
    // Construct API endpoint for error logging
    const productCFNs = products?.map(p => p.cfn).join() || '';
    const queryParams = convertObjectToQueryParams({
        productCFN: productCFNs,
        salesOrg: products?.[0]?.salesOrg || '',
        soldToAccount,
        orderType,
    });
    const apiEndpoint = getValidatedProductsEndpoint(queryParams);
    
    try {
        let result = [];
        let results = [];
        var productsPrice = [];
        var productsPriceResults = [];
        results = yield validateTissueAndNonTissueSalesOrgs(
            action.payload,
            soldToAccount
        );
        // const productsDetailsresults =
        //     yield validateTissueAndNonTissueSalesOrgs(
        //         action.payload,
        //         soldToAccount
        //     );
        // results.push(
        //     yield productsDetailsresults[0][0].then((count) =>
        //         Object.assign({}, count)
        //     )
        // );
        // productsPrice.push(
        //     yield productsDetailsresults[1][0].then((count) =>
        //         Object.assign({}, count)
        //     )
        // );
        results.forEach(({ products }) => {
            result = [...result, ...products];
        });
        productsPrice.forEach(({ priceDetails }) => {
            productsPriceResults = [...productsPriceResults, ...priceDetails];
        });

        const productsForValidation = [];
        products.forEach((product) => {
            const index = productsForValidation.findIndex(
                (item) => item.cfn === product.cfn
            );
            if (index === -1) {
                productsForValidation.push({
                    ...product,
                    quantity: Number(product.quantity),
                });
            } else {
                productsForValidation[index].quantity =
                    productsForValidation[index].quantity +
                    Number(product.quantity);
            }
        });
        const validatedProducts = result;
        const productsToBeAddedToCart = [];
        let validatedProductIndex = 0;
        // let validatedProductIndexValue = 0;

        // calculating products to be added to cart and adding description
        validatedProducts.forEach((validatedProduct) => {
            validatedProductIndex = productsForValidation.findIndex(
                (product) => product.cfn === validatedProduct.productCFN
            );
            // validatedProductIndexValue = productsPriceResults.findIndex(
            //     (product) => product.productCFN === validatedProduct.productCFN
            // );
            validatedProduct.description =
                productsForValidation[validatedProductIndex].description;
            validatedProduct.salesOrg =
                productsForValidation[validatedProductIndex].salesOrg;
            validatedProduct.isSet =
                productsForValidation[validatedProductIndex].isSet;
            // validatedProduct.basePrice =
            //     productsPriceResults[validatedProductIndexValue].basePrice;

            if (
                !validatedProduct.isExcluded &&
                !validatedProduct.isExcludedExtraItem
                // && !(
                //     (inventoryShipping &&
                //         productsForValidation[validatedProductIndex]
                //             .salesOrg ===
                //             TISSUE_AND_NON_TISSUE_SALES_ORG.tissue) ||
                //     (inventoryShipping &&
                //         !productsForValidation[validatedProductIndex].isSet)
                // )
            ) {
                productsToBeAddedToCart.push({
                    ...productsForValidation[validatedProductIndex],
                    quantity: productsForValidation[validatedProductIndex]
                        .quantity
                        ? productsForValidation[validatedProductIndex].quantity
                        : 1,
                    isProductFamily:
                        validatedProduct?.productFamily !== '' &&
                        validatedProduct?.productFamily?.split(',')?.length > 0
                            ? true
                            : false,
                    productFamily:
                        validatedProduct?.productFamily !== '' &&
                        validatedProduct?.productFamily?.split(',')?.length > 0
                            ? validatedProduct?.productFamily?.split(',')
                            : [],
                });
            }
        });

        yield put({
            type: VALIDATE_PRODUCTS_SUCCESS,
            validatedProducts: validatedProducts.map((product) => ({
                ...product,
                productAdded:
                    searchType === 'productSearch' &&
                    productsToBeAddedToCart.length === 1,
                nonInventoryShipping:
                    !product.isExcluded && !product.isExcludedExtraItem
                        ? (inventoryShipping &&
                              product.salesOrg ===
                                  TISSUE_AND_NON_TISSUE_SALES_ORG.tissue) ||
                          (inventoryShipping && !product.isSet)
                        : false,
                productFamily: result[0].productFamily
                    ? result[0].productFamily.split(',')
                    : [],
                basePrice: product.basePrice,
            })),
            statusCode: results[0].statusCode,
            statusMessage: results[0].statusMessage,
        });

        // Logic for stopping duplicate entry
        const existingProducts = yield select(
            (state) => state.equityReducer.cartData.products
        );
        const clonedExistingProducts = [
            ...filterProductsWithQuantityGreaterThanZero(existingProducts),
        ];
        productsToBeAddedToCart.forEach((product) => {
            product.quantity = +product.quantity;
            const productIndex = clonedExistingProducts.findIndex(
                (item) => item.productCFN === product.cfn
            );
            // const productPriceIndex = productsPriceResults.findIndex(
            //     (item) => item.productCFN === product.cfn
            // );
            product.productCFN = product.cfn;
            // clonedExistingProducts[productIndex].basePrice =
            //     productsPriceResults.length > 0
            //         ? productsPriceResults[productPriceIndex].basePrice
            //         : 0;
            delete product.cfn;
            if (product.salesOrg === 'S002') product.shippingRequirement = true;
            // product.batchParked = false;
            if (productIndex !== -1 && !product.isSet) {
                clonedExistingProducts[productIndex].quantity =
                    parseInt(clonedExistingProducts[productIndex].quantity) +
                    parseInt(product.quantity);
            } else if (productIndex === -1 && !product.isSet) {
                clonedExistingProducts.push({
                    ...product,
                    productKey: generate_UUID(),
                });
            } else {
                for (let i = 1; i <= Number(product.quantity); i++) {
                    let productModified = {
                        ...product,
                        productKey: generate_UUID(),
                        quantity: 1,
                    };
                    clonedExistingProducts.push(productModified);
                }
            }
        });
        // updating cart data
        yield put(setCartData({ products: clonedExistingProducts }));

        // Added a delay of 1200ms for showing added and tick mark in ui
        // this will re-render the ui with productAdded as false, so tick mark will disapper after 1200ms
        if (
            searchType === 'productSearch' &&
            productsToBeAddedToCart.length === 1
        ) {
            yield delay(1500);

            yield put({
                type: VALIDATE_PRODUCTS_SUCCESS,
                validatedProducts: [
                    {
                        productCFN: result[0].productCFN,
                        productAdded: false,
                        isExcluded: result[0].isExcluded,
                        productFamily: result[0].productFamily
                            ? result[0].productFamily.split(',')
                            : [],
                    },
                ],
                statusCode: results[0].statusCode,
                statusMessage: results[0].statusMessage,
            });
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: apiEndpoint,
            requestPayload: action.payload
        });
        yield put({
            type: VALIDATE_PRODUCTS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}